import { Injectable } from '@angular/core';
import { ApiService } from '../../../../services/apiservice/apiservice.service';
import { ConfigService } from '../../../../services/config/config.service';
import { Observable } from 'rxjs';
import { SearchQuery } from '../../../../core/interfaces/search.interface';
import { SharedService } from '../../../../services/shared/shared.service';
import { HttpClient } from '@angular/common/http';

export interface Age {
  min: number;
  max: number;
  grade: string;
  searchQuery: SearchQuery;
}

export interface Award {
  year: number;
  title: string;
  status: string;
}
export interface Review {
  by: string;
  source: string;
  content: string;
}
export interface AcceleratedReader {
  interestLevel: string;
  titlePoint: string;
  atos: string;
  searchQuery: SearchQuery;
}
export interface Lexile {
  code: string;
  definition: string;
  measure: string;
  searchQuery: SearchQuery;
}
export interface ReadingCounts {
  readingLevel: string;
  interestLevel: string;
  titlePoint: string;
  searchQuery: SearchQuery;
}
export interface StudyProgram {
  acceleratedReader: AcceleratedReader;
  lexile: Lexile;
  readingCounts: ReadingCounts;
}
export interface ClcdContent {
  clcdGuid: string;
  age: Age;
  awards: Award[];
  booksLikeThis: string[];
  reviews: Review[];
  studyProgram: StudyProgram;
}

@Injectable({
  providedIn: 'root',
})
export class ClcdService {
  private _clcdUrl: string;

  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
    private _sharedService: SharedService,
    private _http: HttpClient,
  ) {
    this._clcdUrl = `${this._configService.agApi}/econtent/clcd`;
  }

  getClcdContent(clcd: string, searchId: string): Observable<ClcdContent> {
    return this._apiService.get(`${this._clcdUrl}/${clcd}?searchId=${searchId}`);
  }

  getBooksLikeThis(clcds: string[]): Observable<any> {
    return this._http.post(`${this._clcdUrl}/bookslikethis`, clcds, {
      params: {
        isKidsSearch: this._sharedService.getIsKidsCat(),
      },
    });
  }
}
